import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {injectIntl} from "react-intl";

import {CloningGroupNameAll, setCloningFeatureFilters} from './FabricatorsActions';
import FeaturesFilters from "../FeatureCreator/FeaturesFilters/FeaturesFilters";
import {loadFeaturesSetupFeatures} from "../FeaturesSetup/featuresAsyncActions";
import {clearFeaturesSetup} from "../FeaturesSetup/featuresActions";

const FabricatorsFeaturesFilters = (props) => {

  const {cloningFabFeaturesSelectedGroup, loadFeaturesSetupFeatures, fabricator, clearFeaturesSetup,
    setCloningFeatureFilters, featuresListReceived} = props;

  useEffect(() => {
    clearFeaturesSetup()
    return () => {
      clearFeaturesSetup()
    }
  }, [cloningFabFeaturesSelectedGroup])

  if (!cloningFabFeaturesSelectedGroup || (cloningFabFeaturesSelectedGroup === CloningGroupNameAll)) {
    return null
  }

  const onFiltersOpened = async () => {
    if (featuresListReceived) {
      return
    }
    const projectScopeFeatures = await loadFeaturesSetupFeatures(cloningFabFeaturesSelectedGroup, 0, fabricator.id);
    if (Array.isArray(projectScopeFeatures) && projectScopeFeatures.length) {
      setCloningFeatureFilters(projectScopeFeatures);
    }
  }

  return <FeaturesFilters featureGroupName={cloningFabFeaturesSelectedGroup}
                          forFabricatorId={fabricator.id}
                          onOpened={onFiltersOpened}
                          featuresSetupPage={true}/>
}


FabricatorsFeaturesFilters.propTypes = {
  fabricator: PropTypes.object.isRequired,
};


const mapStateToProps = state => {
  const {cloningFabFeaturesSelectedGroup} = state.fabricators;
  const {featuresListReceived} = state.featuresSetupState;
  return {
    cloningFabFeaturesSelectedGroup,
    featuresListReceived,
  }
};

const mapDispatchToProps = {
  loadFeaturesSetupFeatures,
  clearFeaturesSetup,
  setCloningFeatureFilters,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FabricatorsFeaturesFilters)
);


